import { useEffect, useState, useRef } from "react";
import { LeadViewDrawer } from "../components";
import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, IconButton, Image, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Popover, PopoverCloseButton, PopoverContent, PopoverTrigger, Text, Tooltip, useDisclosure } from "@chakra-ui/react";
import MyDiv from "./myTeamCreatedLead.style";
import { useFetch } from "../../../hooks/useFetch";
import { AlertCard, CustomToast } from "../../../components";
import { getStatusRank, ILead, ILeadTable } from "../LeadPool/model";
import useDebounce from "../../../hooks/useDebounce";
import { useAuth } from "../../../hooks/useAuth";
import MyTeamLeadList from "../components/MyTeamLeadList/myTeamLeadList";
import CustomPagination from "../../../components/CustomPagination";
import MyTeamLeadHistory from "../components/MyTeamLeadHistory/myTeamLeadHistory";
import FilterCard, { IFilterOptions } from "../../../components/FilterCard/filterCard";
import { ChevronDownIcon, DownloadIcon, Search2Icon } from "@chakra-ui/icons";
import { useLocation, Link } from "react-router-dom";
import * as routesNames from "../../../constant/routes";
import { pageMapping } from "../../../utilities/pageMapping";
import UniversalActivityHistory from "../../../components/History";
import DateRangePicker from "../../../components/DatePicker/datePicker";
import quickLeadTemplate from "../../../assets/templates/bulk-upload-template.xlsx";
import MyTeamCreatedLeadList from "../components/MyTeamCreatedLeadList";


const sortOptions = [
  "Latest Leads",
  "Oldest Leads",
  "Recently Updated",
  "Hot Leads First",
  "Company Name (A-Z)",
  "Company Name (Z-A)",
];

const sortMapping: Record<
  string,
  { field: string; order: 1 | -1 }
> = {
  "Latest Leads": { field: "createdAt", order: -1 },
  "Oldest Leads": { field: "createdAt", order: 1 },
  "Recently Updated": { field: "updatedAt", order: -1 },
  "Hot Leads First": { field: "priority", order: -1 },
  "Company Name (A-Z)": { field: "companyName", order: 1 },
  "Company Name (Z-A)": { field: "companyName", order: -1 },
};

const MyTeamCreatedLead = () => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const fetchIdRef = useRef(0);
  const [leadData, setLeadData] = useState<ILeadTable>({ leads: [], totalCount: 0 });
  const [selectedLeads, setSelectedLeads] = useState<ILead | null>(null);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [search, setSearch] = useState("");
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [viewLead, setViewLead] = useState<ILead | null>(null);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [historyLead, setHistoryLead] = useState<ILead | null>(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [pagination, setPagination] = useState({ skip: 0, limit: 10 });
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [selectedLeadIds, setSelectedLeadIds] = useState<number[]>([]);
  const [selectAllLeads, setSelectAllLeads] = useState(false);
  const [selectedLeadsData, setSelectedLeadsData] = useState<any[]>([]);
  const debounceSearch = useDebounce(search, 700);
  const { hasPermission } = useAuth();
  const [revealedFields, setRevealedFields] = useState<{ rowIndex: number; field: string }[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [lazyParams, setLazyParams] = useState({ first: 0, rows: 100, page: 0, sortField: "", sortOrder: 1 });
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState(sortOptions[0]);
  const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {}, });
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [excelFile, setExcelFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState<any>(null);
  const [maskingSettings, setMaskingSettings] = useState<any>({});
  // const [dateRange, setDateRange] = useState<{ start: Date; end: Date; } | null>(() => {
  //   const today = new Date();
  //   const day = today.getDay();
  //   const diff = day === 0 ? -6 : 1 - day;
  //   const start = new Date(today);
  //   start.setDate(today.getDate() + diff);
  //   start.setHours(0, 0, 0, 0);

  //   const end = new Date(start);
  //   end.setDate(start.getDate() + 6);
  //   end.setHours(23, 59, 59, 999);
  //   return { start, end };
  // });
  const [dateRange, setDateRange] = useState<{
    start: Date;
    end: Date;
  } | null>(null);
  // SINGLE FIELD REVEAL
  const [revealedField, setRevealedField] = useState<{
    rowIndex: number | null;
    field: string | null;
  }>({
    rowIndex: null,
    field: null,
  });

  // FULL ROW REVEAL
  const [revealedRow, setRevealedRow] = useState<number | null>(null);



  const canViewAllContacts = hasPermission("MyTeamLead", "ViewAllContact");
  const canViewOnlyContacts = hasPermission("MyTeamLead", "ViewOnlyContact");
  const canHideContacts = hasPermission("MyTeamLead", "HideContact");
  const canViewRowContacts = hasPermission("MyTeamLead", "ViewRowContact");


  const [query, setQuery] = useState<{
    filter: Record<string, number[]>;
    lazyParams: { first: number; rows: number; page: number; sortField: string; sortOrder: number; };
  }>({
    filter: {}, lazyParams: { ...lazyParams },
  });
  const pageCount = Math.ceil(totalCount / lazyParams.rows);

  const toggleReveal = (rowIndex: number, field: string) => {
    if (canViewOnlyContacts) {
      setRevealedField({
        rowIndex,
        field,
      });
      return;
    }
    if (canViewRowContacts) {
      setRevealedRow(rowIndex);
      return;
    }
  };

  const maskText = (text?: string) => {
    if (!text) return "";
    return "*".repeat(text.length);
  };

  function pageChangeFunction(e: { skip: number; limit: number }) {
    setPagination(e);
  }

  const handleEditLead = (row: ILead) => {
    setSelectedLeads(row);
    setShowForm(true);
  };

  useEffect(() => {
    setLazyParams((prev) => ({
      ...prev,
      first: 0,
      page: 0,
    }));
  }, [debounceSearch]);

  const loadLeads = async () => {
    setLoading(true);
    const fetchId = ++fetchIdRef.current;

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const params = new URLSearchParams({
      lazyParams: JSON.stringify(query.lazyParams),
      search: debounceSearch,
      filter: JSON.stringify(query.filter ?? {}),
      timeZone: timezone,
    });

    if (dateRange) {
      params.append("startDate", formatDate(dateRange.start));
      params.append("endDate", formatDate(dateRange.end));
    }
    const res = await fetchApi("CreateLead/TeamLead", "GET", "", params.toString(), "");

    if (fetchId !== fetchIdRef.current) {
      return;
    }

    if (res) {
      setLeadData(res);
      setTotalCount(res.totalCount);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadLeads();
  }, [query, debounceSearch, dateRange]);

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleDateRangeChange = (
    newRange: { start: Date; end: Date } | null
  ) => {
    setDateRange(prev => {
      if (prev && newRange &&
        prev.start.getTime() === newRange.start.getTime() &&
        prev.end.getTime() === newRange.end.getTime()) {
        return prev;
      }
      return newRange;
    });
  };

  const handleViewLead = (lead: ILead) => {
    setViewLead(lead);
    setIsViewOpen(true);
  };

  const handlePageClick = ({ selected, }: { selected: number; }) => {
    const first = selected * query.lazyParams.rows;
    setQuery((prev) => ({
      ...prev,
      lazyParams: {
        ...prev.lazyParams,
        page: selected,
        first,
      },
    }));
  };

  const handleHistoryLead = (lead: ILead) => {
    setHistoryLead(lead);
    setIsHistoryOpen(true);
  };

  const handleSelfAssign = async (leadId?: number) => {
    const res = await fetchApi(`Lead/SelfAssign/${leadId}`, "POST", null);
    if (res) {
      addToast({ message: "Lead assigned to you", status: "success" });
      loadLeads();
    }
  };

  const toggleSelectLead = (id: number) => {
    setSelectedLeadIds((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  const toggleSelectAllLeads = () => {
    if (selectAllLeads) {
      setSelectedLeadIds([]);
    } else {
      const allIds = leadData.leads.map((item: any) => item.leadId);

      setSelectedLeadIds(allIds);
    }
    setSelectAllLeads(!selectAllLeads);
  };

  const loadFilter = async () => {
    const response = await fetchApi<IFilterOptions>("Filters/createdByModelFilter", "GET", null, null, "");
    if (response) {
      if (response.filterOptions && response.filterOptions["Status"]) {
        response.filterOptions["Status"] = [...response.filterOptions["Status"]].sort((a: any, b: any) => {
          return getStatusRank(a.name) - getStatusRank(b.name);
        });
      }
      setFilter(response);
    }
  };

  useEffect(() => {
    loadFilter();
  }, []);


  const handleSort = (option: string) => {
    setSelectedSort(option);
    const sortConfig = sortMapping[option];
    if (sortConfig) {
      setQuery((prev) => ({
        ...prev,
        lazyParams: { ...prev.lazyParams, sortField: sortConfig.field, sortOrder: sortConfig.order, page: 0, first: 0, },
      }));
    }
  };

  const { loginObj } = useAuth();
  const location = useLocation();

  const loadMaskingSettings = async () => {
    const pageId = pageMapping[location.pathname];
    const roleId = loginObj?.roleId?.[0];
    const res = await fetchApi(`FieldMaskingSettings/GetMaskingSettings?pageId=${pageId}&roleId=${roleId}`, "GET");
    if (res) {
      const formatted: any = {};
      res.forEach((item: any) => {
        formatted[item.fieldName] = item.maskType;
      });
      setMaskingSettings(formatted);
    }
  };


  useEffect(() => {
    loadMaskingSettings();
  }, []);











  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setExcelFile(e.target.files[0]);
    }
  };

  const uploadExcel = async () => {
    if (!excelFile) { addToast({ message: "Please select a file", status: "warning" }); return; }

    const checkRes = await fetchApi("Status/CheckActiveUpload", "GET");
    if (checkRes && checkRes.isProcessing) {
      addToast({
        message: "A bulk upload is already in progress. Please wait until the current upload is completed.",
        status: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", excelFile);
    setUploading(true);

    addToast({
      message: (
        <span>
          Your bulk upload has started and may take a few minutes to complete. If you want to track the upload status,{" "}
          <Link to={routesNames.BULKUPLOADLEAD} style={{ color: "#2B6CB0", textDecoration: "underline", fontWeight: "bold" }}>
            click here
          </Link>
          .
        </span>
      ),
      status: "info",
      duration: 8000,
    });

    handleClose();

    const response = await fetchApi("Status/ImportQuickLeadExcel", "POST", formData, null, undefined, true);
    setUploading(false);
    if (response) {
      setUploadResult(response);
      loadLeads();
    }
  };

  const handleClose = () => {
    if (uploading) return;
    setBulkUploadOpen(false);
    setExcelFile(null);
    setUploadResult(null);
    onClose();
  };


  return (
    <MyDiv>
      <Box className="top-section">
        <Text className="font-poppins text_xxl text_semibold"> Team Created Leads </Text>

        <Flex align="center" gap={3}>


          <InputGroup width="220px">
            <InputLeftElement pointerEvents="none">
              <Search2Icon color="gray.500" />
            </InputLeftElement>
            <Input placeholder="Search by comp/poc name..." value={search} onChange={(e) => setSearch(e.target.value)} bg="white" />
          </InputGroup>

          <DateRangePicker
            maxDate={new Date()}
            onChange={handleDateRangeChange}
            showAdvancedFilters={false}
          //  defaultCurrentWeek

          />




          <Text fontSize="14px" fontWeight="500">  Filter  </Text>

          <Popover placement="bottom-start" closeOnBlur>
            <PopoverTrigger>
              <Button rightIcon={<ChevronDownIcon />} bg="#F9FAFB" border="1px solid #D0D5DD" fontSize="14px" minW="140px" justifyContent="space-between"
              >
                Process
              </Button>
            </PopoverTrigger>

            <FilterCard filter={filter} selectedFilters={query.filter}
              onApply={(filters) => {
                const _filter: Record<string, number[]> = {};

                Object.keys(filters).forEach((key) => {
                  if (filters[key].length > 0) { _filter[key.replace(/ /g, "")] = filters[key]; }
                });

                setQuery((prev) => ({
                  ...prev, lazyParams: { ...prev.lazyParams, page: 0, first: 0, },
                  filter: _filter,
                }));
              }}
            />
          </Popover>


          <Text fontSize="14px" fontWeight="500"> Sort By  </Text>

          <Popover placement="bottom-start" closeOnBlur isOpen={isSortOpen} onClose={() => setIsSortOpen(false)} >
            <PopoverTrigger>
              <Button rightIcon={<ChevronDownIcon />} bg="#F9FAFB" border="1px solid #D0D5DD" fontSize="14px" minW="140px" justifyContent="space-between" onClick={() => setIsSortOpen(true)} >
                {selectedSort}
              </Button>
            </PopoverTrigger>

            <PopoverContent w="220px">
              <Box px={4} py={3} borderBottom="1px solid #E5E7EB" position="relative" >
                <Text textAlign="center" fontSize="14px" fontWeight="500" >  Sort By </Text>
                <PopoverCloseButton top="8px" right="12px" />
              </Box>

              <Box maxH="220px" overflowY="auto">
                {sortOptions.map((option) => (
                  <Box key={option} px={2} py={2} cursor="pointer" bg={
                    selectedSort === option ? "#F3F4F6" : "#FFFFFF"}
                    _hover={{ bg: "#F9FAFB" }}
                    onClick={() => {
                      handleSort(option); setIsSortOpen(false);
                    }}
                  >
                    <Text fontSize="14px">{option}</Text>
                  </Box>
                ))}
              </Box>
            </PopoverContent>


          </Popover>

        </Flex>
      </Box>

      <MyTeamCreatedLeadList
        maskingSettings={maskingSettings}
        revealedField={revealedField}
        revealedRow={revealedRow}
        canViewAllContacts={canViewAllContacts}
        canViewOnlyContacts={canViewOnlyContacts}
        canViewRowContacts={canViewRowContacts}
        canHideContacts={canHideContacts}
        leadData={leadData}
        loading={loading}
        search={search}
        setSearch={setSearch}
        pagination={pagination}
        pageChangeFunction={pageChangeFunction}
        toggleReveal={toggleReveal}
        maskText={maskText}
        handleEditLead={handleEditLead}
        handleViewLead={handleViewLead}
        handleHistoryLead={handleHistoryLead}
        handleSelfAssign={handleSelfAssign}
        selectedLeads={selectedLeadIds}
        toggleSelectLead={toggleSelectLead}
        toggleSelectAllLeads={toggleSelectAllLeads}
        selectAllLeads={selectAllLeads}
        setIsAssignModalOpen={setIsAssignModalOpen}
        setSelectedLeadsData={setSelectedLeadsData}
        setSelectedLeadIds={setSelectedLeadIds}
        setSelectAllLeads={setSelectAllLeads}
        loadLeads={loadLeads}
      />

      {/* DETAILS DRAWER */}

      <Drawer isOpen={isViewOpen} placement="right" size="md" onClose={() => setIsViewOpen(false)}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader className="font-poppins text_lg text_semibold">Lead Details</DrawerHeader>
          <DrawerBody>
            <LeadViewDrawer lead={viewLead} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>


      <Modal isOpen={bulkUploadOpen} onClose={handleClose} isCentered>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            {uploadResult ? "Upload Summary" : "Upload Quick Leads"}
          </ModalHeader>
          <ModalBody>
            {!uploadResult ? (
              // Upload UI
              <Box border="2px dashed #4048D6" borderRadius="14px" bg="#F8F9FF" minH="220px" display="flex" alignItems="center" justifyContent="center"
                textAlign="center" cursor="pointer" onClick={() => document.getElementById("quickLeadFile")?.click()}
              >
                <Input id="quickLeadFile" type="file" accept=".xlsx" display="none" onChange={handleFileChange} />

                {!excelFile ? (
                  <Box>
                    <Image src="https://cdn-icons-png.flaticon.com/512/2991/2991112.png" boxSize="60px" mx="auto" mb={4} />
                    <Text fontWeight="600">Click to upload Excel file</Text>
                    <Text fontSize="13px" color="gray.500">
                      Supported format: .xlsx
                    </Text>
                  </Box>
                ) : (
                  <Box>
                    <Image src="https://cdn-icons-png.flaticon.com/512/732/732220.png" boxSize="60px" mx="auto" mb={4} />

                    <Text fontWeight="600">{excelFile.name}</Text>

                    <Text fontSize="13px" color="gray.500">
                      {(excelFile.size / 1024).toFixed(1)} KB
                    </Text>
                  </Box>
                )}
              </Box>
            ) : (
              // Upload Summary
              <Box>


                <Flex justify="space-between" bg="#F9FAFB" p={4} borderRadius="10px" mb={5} >
                  <Box textAlign="center">
                    <Text fontSize="13px">Total</Text>
                    <Text fontSize="22px" fontWeight="700"> {uploadResult.totalRows} </Text>
                  </Box>

                  <Box textAlign="center">
                    <Text fontSize="13px">Success</Text>
                    <Text fontSize="22px" fontWeight="700" color="green.500"> {uploadResult.successCount} </Text>
                  </Box>

                  <Box textAlign="center">
                    <Text fontSize="13px">Failed</Text>
                    <Text fontSize="22px" fontWeight="700" color="red.500"> {uploadResult.failedCount} </Text>
                  </Box>
                </Flex>

                {uploadResult.failedRows?.length > 0 && (
                  <Box maxH="260px" overflowY="auto" border="1px solid #E2E8F0" borderRadius="10px" >
                    {uploadResult.failedRows.map((item: any, index: number) => (
                      <Box
                        key={index}
                        p={4}
                        borderBottom={
                          index !== uploadResult.failedRows.length - 1
                            ? "1px solid #EDF2F7"
                            : "none"
                        }
                      >
                        <Text fontWeight="600">
                          {item.contact}
                        </Text>

                        <Text fontSize="13px" color="gray.600">
                          <b>Email:</b> {item.email || "-"}
                        </Text>

                        <Text fontSize="13px" color="gray.600">
                          <b>Phone:</b> {item.phone || "-"}
                        </Text>

                        <Text color="red.500" fontSize="13px" mt={2}>
                          {item.error}
                        </Text>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}
          </ModalBody>

          <ModalFooter>
            {!uploadResult ? (
              <>
                <Button mr={3} variant="ghost" onClick={handleClose} isDisabled={uploading}> Cancel </Button>
                <Button bg="#4048D6" color="#FFFFFF" _hover={{ bg: "#353CC4" }} onClick={uploadExcel} isLoading={uploading} isDisabled={!excelFile} >
                  Upload
                </Button>
              </>
            ) : (
              <Button bg="#4048D6" color="#FFFFFF" _hover={{ bg: "#353CC4" }}
                onClick={() => { setUploadResult(null); setExcelFile(null); handleClose(); loadLeads(); }}
              >
                Done
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Drawer isOpen={isHistoryOpen} placement="right" size="md" onClose={() => setIsHistoryOpen(false)}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader className="font-poppins text_lg text_semibold">History</DrawerHeader>
          <DrawerBody>
            <UniversalActivityHistory module="Lead" recordId={historyLead?.leadId} />
            {/* <LeadHistory lead={historyLead} /> */}
            {/* <MyTeamLeadHistory lead={historyLead} /> */}
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <CustomPagination
        pageCount={pageCount}
        handlePageClick={handlePageClick}
        rowsPerPage={query.lazyParams.rows}
        rowsPerPageOptions={[50, 100, 200, 500]}
        setRowsPerPage={(value: number) => setQuery((prev) => ({ ...prev, lazyParams: { ...prev.lazyParams, rows: value, page: 0, first: 0, }, }))}
        totalRecords={totalCount}
        currentPage={query.lazyParams.page}
      />

      {/* <GenerateLeadModal isOpen={isAssignModalOpen} onClose={() => setIsAssignModalOpen(false)} selectedPOCs={selectedLeadsData.map((item) => item.pocId)} selectedCompany={null} /> */}
      <AlertCard isOpen={isAlertOpen} onClose={() => setIsAlertOpen(false)} onConfirm={() => handleSelfAssign()} title="Self Assign Lead" description="Are you sure you want to self assign this lead?" colorScheme="blue" />
    </MyDiv>
  );
};

export default MyTeamCreatedLead;
